module.exports = __webpack_public_path__ + "autopilot-feedback-hero-2fb237f1a16b2f80e45ad9b3b8604e08.png";